export const UPDATE_POINT_REQUEST = 'UPDATE_POINT_REQUEST';
export const UPDATE_POINT_SUCCESS = 'UPDATE_POINT_SUCCESS';
export const UPDATE_POINT_FAILED = 'UPDATE_POINT_FAILED';
